module.exports = __webpack_public_path__ + "static/media/haute9C.251a34a0.jpg";